module.exports = __webpack_public_path__ + "img/discount-riseup-friends.2fcedb90.svg";